export default {
  "it-IT": {
    customFeesEstimateShortMessage:
          "Su RUNKD paghi il totale dell'ordine, eventuali altre spese verranno incassate alla consegna.",
    whatDoesItMean: "Cosa significa?"
  },
  "fr-FR": {
      customFeesEstimateShortMessage:
          "Sur RUNKD vous payez le total de la commande, tous les autres frais seront encaissés à la livraison.",
      whatDoesItMean: "Qu'est-ce que cela veut dire ?"
  },
  "es-ES": {
      customFeesEstimateShortMessage:
          "En RUNKD pagas el total del pedido, eventuales gastos adicionales serán abonados en el momento de la entrega.",
      whatDoesItMean: "¿Qué significa esto?"
  },
  "en-GB": {
      customFeesEstimateShortMessage:
          "On RUNKD you pay the full amount of the order, any additional costs will be paid at the time of delivery.",
      whatDoesItMean: "What does it mean?"
  },
  "en-US": {
    customFeesEstimateShortMessage:
          "On RUNKD you pay the full amount of the order, any additional costs will be paid at the time of delivery.",
    whatDoesItMean: "What does it mean?"
  },
  "ko-KR": {
      customFeesEstimateShortMessage:
          "RUNKD에서는 주문의 총 가격을 지불하십니다. 추가 발생 비용은 제품 수령 시 지불하십시오. ",
      whatDoesItMean: "무슨 뜻입니까?"
  },
  "de-DE": {
      customFeesEstimateShortMessage:
          "Auf RUNKD bezahlen Sie den Gesamtbetrag der Bestellung, alle anderen Kosten werden bei Lieferung erhoben.",
      whatDoesItMean: "Was bedeutet das?"
  },
};
